import {Reducer} from "redux";
import {IHubNode} from "../../model/IHubNode";
import {
  NODES_CONFIG_MERGED_NODE_ADD_NODE_DIALOG_VISIBILITY_SET,
  NODES_CONFIG_MERGED_NODE_CLEAR,
  NODES_CONFIG_MERGED_NODE_CREATE,
  NODES_CONFIG_MERGED_NODE_DIALOG_VISIBILITY_SET,
  NODES_CONFIG_MERGED_NODE_EDIT,
  NODES_CONFIG_MERGED_NODE_EDIT_NODE_DIALOG_VISIBILITY_SET,
  NODES_CONFIG_MERGED_NODE_FETCH,
  NODES_CONFIG_MERGED_NODE_ID_SET,
  NODES_CONFIG_NODE_CLEAR,
  NODES_CONFIG_NODE_CREATE,
  NODES_CONFIG_NODE_DASHBOARDS_CLEAR,
  NODES_CONFIG_NODE_DASHBOARDS_CLEAR_ALL,
  NODES_CONFIG_NODE_DASHBOARDS_DASHBOARD_ADD,
  NODES_CONFIG_NODE_DASHBOARDS_DASHBOARD_REMOVE,
  NODES_CONFIG_NODE_DASHBOARDS_FETCH,
  NODES_CONFIG_NODE_DASHBOARDS_FETCH_ALL,
  NODES_CONFIG_NODE_DASHBOARDS_ORDERS_SEND,
  NODES_CONFIG_NODE_DASHBOARDS_SUBMIT,
  NODES_CONFIG_NODE_EDIT,
  NODES_CONFIG_NODE_FETCH,
  NODES_CONFIG_NODE_ID_SET,
  NODES_CONFIG_NODE_VISIBILITY_SET,
  NODES_CONFIG_NODES_CLEAR,
  NODES_CONFIG_NODES_FETCH
} from "./nodesConfigActions";
import {REQUEST_START, REQUEST_SUCCESS} from "../../middlewares/request/requestActions";

export type NodesConfigState = {
  nodes: IHubNode[] | null;
  isNodeVisible: boolean;
  nodeId: number | null;
  node: IHubNode | null;
  initialNodeVisibility: number | null;
  nodeDashboards: any; // any[] | null;
  allDashboards: any[] | null;
  isMergedNodeDialogVisible: boolean;
  mergedNode: IHubNode | null;
  mergedNodeId: number | null;
  isAddNodeDialogOpen: boolean;
  isEditNodeDialogOpen: boolean;
  idxMergeEditNode: number | null;
};

const nodesConfigReducer: Reducer<NodesConfigState, any> = (
  state = {
    nodes: null,
    isNodeVisible: false,
    nodeId: null,
    node: null,
    initialNodeVisibility: null,
    nodeDashboards: null,
    allDashboards: null,
    isMergedNodeDialogVisible: false,
    mergedNode: null,
    mergedNodeId: null,
    isAddNodeDialogOpen: false,
    isEditNodeDialogOpen: false,
    idxMergeEditNode: null
  },
  action
) => {
  switch (action.type) {
    case NODES_CONFIG_NODES_CLEAR: {
      return {
        ...state,
        nodes: null
      };
    }
    case NODES_CONFIG_NODE_VISIBILITY_SET: {
      return {
        ...state,
        isNodeVisible: action.visible
      };
    }
    case NODES_CONFIG_NODE_ID_SET: {
      return {
        ...state,
        nodeId: action.nodeId
      };
    }
    case NODES_CONFIG_NODE_CLEAR: {
      return {
        ...state,
        node: null,
        initialNodeVisibility: null
      };
    }
    case NODES_CONFIG_NODE_DASHBOARDS_CLEAR: {
      return {
        ...state,
        nodeDashboards: null
      };
    }
    case NODES_CONFIG_NODE_DASHBOARDS_CLEAR_ALL: {
      return {
        ...state,
        allDashboards: null
      };
    }
    case NODES_CONFIG_MERGED_NODE_CLEAR: {
      return {
        ...state,
        mergedNode: null,
        mergedNodeId: null,
        isAddNodeDialogOpen: false,
        isEditNodeDialogOpen: false,
        idxMergeEditNode: null
      };
    }
    case NODES_CONFIG_MERGED_NODE_ID_SET: {
      return {
        ...state,
        mergedNodeId: action.nodeId
      };
    }
    case NODES_CONFIG_MERGED_NODE_DIALOG_VISIBILITY_SET: {
      return {
        ...state,
        isMergedNodeDialogVisible: action.visible
      };
    }
    case NODES_CONFIG_MERGED_NODE_ADD_NODE_DIALOG_VISIBILITY_SET: {
      return {
        ...state,
        isAddNodeDialogOpen: action.visible
      };
    }
    case NODES_CONFIG_MERGED_NODE_EDIT_NODE_DIALOG_VISIBILITY_SET: {
      return {
        ...state,
        isEditNodeDialogOpen: action.visible,
        idxMergeEditNode: action.idx
      };
    }

    case REQUEST_START: {
      switch (action.payload.label) {
        case NODES_CONFIG_NODE_EDIT: {
          return {
            ...state,
            node: null,
            initialNodeVisibility: null
          };
        }
        case NODES_CONFIG_MERGED_NODE_EDIT: {
          return {
            ...state,
            mergedNode: null
          };
        }
        default:
          return state;
      }
    }
    case REQUEST_SUCCESS: {
      switch (action.payload.label) {
        case NODES_CONFIG_NODES_FETCH: {
          return {
            ...state,
            nodes: action.payload.response
          };
        }
        case NODES_CONFIG_NODE_FETCH: {
          return {
            ...state,
            node: action.payload.response,
            initialNodeVisibility: action.payload.response.visible
          };
        }
        case NODES_CONFIG_NODE_CREATE:
        case NODES_CONFIG_NODE_EDIT:
          return {
            ...state,
            nodeId: null,
            isNodeVisible: false,
            node: null,
            initialNodeVisibility: null
          };
        case NODES_CONFIG_NODE_DASHBOARDS_FETCH:
          return {
            ...state,
            nodeDashboards: action.payload.response
          };
        case NODES_CONFIG_NODE_DASHBOARDS_FETCH_ALL:
          return {
            ...state,
            allDashboards: action.payload.response
          };
        case NODES_CONFIG_NODE_DASHBOARDS_SUBMIT:
          return {
            ...state
          };
        case NODES_CONFIG_NODE_DASHBOARDS_DASHBOARD_ADD:
          return {
            ...state,
            allDashboards: null,
            nodeDashboards: null
          };
        case NODES_CONFIG_NODE_DASHBOARDS_DASHBOARD_REMOVE:
        case NODES_CONFIG_NODE_DASHBOARDS_ORDERS_SEND:
          return {
            ...state,
            nodeDashboards: null
          };
        case NODES_CONFIG_MERGED_NODE_CREATE:
        case NODES_CONFIG_MERGED_NODE_EDIT:
          return {
            ...state,
            mergedNodeId: null,
            isMergedNodeDialogVisible: false,
            mergedNode: null,
            isAddNodeDialogOpen: false,
            isEditNodeDialogOpen: false,
            idxMergeEditNode: null
          };
        case NODES_CONFIG_MERGED_NODE_FETCH: {
          const mergedNodeResponse = action.payload.response;
          (mergedNodeResponse?.mergeNodes || []).sort((a, b) => a.position - b.position);
          return {
            ...state,
            mergedNode: mergedNodeResponse
          };
        }
        default:
          return state;
      }
    }
    default:
      return state;
  }
};

export default nodesConfigReducer;
